import { ProjectDashboardsTab } from "@/components/projects/project-dashboards-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId/dashboards",
)({
	component: ProjectDashboardsTab,
});
